import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63990a46"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "admin-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import useRoleStore from "@/store/modules/role";
import { storeToRefs } from "pinia";
import { setRoleStatusApi } from "@/service/modules/role";
export default /*#__PURE__*/_defineComponent({
  __name: 'admin-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "addSubset"
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const route = useRoute();
    const router = useRouter();
    const form = reactive({
      id: "",
      username: "",
      password: "",
      role_id: "",
      status: 1
    });
    const formRef = ref();
    const roleStore = useRoleStore();
    const {
      allRoleList
    } = storeToRefs(roleStore);
    const rules = {
      username: [{
        required: true,
        message: "请输入账号",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }],
      role_id: [{
        required: true,
        message: "请分配角色",
        trigger: "change"
      }],
      status: [{
        required: true,
        message: "请选择状态",
        trigger: "change"
      }]
    };
    const subBtnLoading = ref(false);
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加账号";
      } else if (props.dialogType === "edit") {
        return "编辑账号";
      }
    });
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      formRef.value?.resetFields();
      emit("closeDialog");
    }
    function restForm() {
      form.id = "";
      form.username = "";
      form.password = "";
      form.role_id = null;
      form.status = 1;
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      try {
        if (form.id && !form.password) delete form.password;
        let res = await setRoleStatusApi(form);
        ElMessage.success(props.dialogType === "add" ? "添加成功" : "修改成功");
        subBtnLoading.value = false;
        closeDialog();
        emit("restData");
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(() => {
          formRef.value?.resetFields();
          if (props.dialogType === "edit") {
            for (let key in form) {
              form[key] = props.itemData[key];
              form.password = "";
            }
            form.role_id = Number(form.role_id);
          }
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[5] || (_cache[5] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "账号",
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.username = $event),
              placeholder: "请输入账号",
              disabled: __props.dialogType === 'edit'
            }, null, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密码",
            prop: form.id ? '' : 'password'
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "password",
              "show-password": "",
              modelValue: form.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.password = $event),
              placeholder: "请输入密码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["prop"]), _createVNode(_component_el_form_item, {
            label: "分配角色",
            prop: "role_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              class: "w100",
              modelValue: form.role_id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.role_id = $event),
              placeholder: "请分配角色"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allRoleList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 256))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否启用",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.status,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.status = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});